import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { CnLoading } from '@sto/cn-ui';

let loadingSetter;
function LoadingComp() {
  const [visible, setVisible] = useState(false);
  loadingSetter = setVisible;
  return (
    <span>
      <CnLoading visible={visible} fullScreen />
    </span>
  );
}
let timer;
let loadingNode;
// 显示全局 loading
export const showLoading = () => {
  if (timer) {
    clearTimeout(timer);
    timer = null;
  }
  loadingNode = document.createElement('div');
  loadingNode.setAttribute('id', 'full#loading');
  document.body.appendChild(loadingNode);
  timer = setTimeout(() => {
    ReactDOM.render(<LoadingComp />, document.getElementById('full#loading'));
    // createRoot(document.getElementById('full#loading')!).render(<LoadingComp />);
    if (loadingSetter instanceof Function) loadingSetter(true);
  }, timer);
};
// 隐藏 loading
export const hideLoading = () => {
  if (timer) {
    clearTimeout(timer);
    timer = null;
  }
  if (loadingSetter instanceof Function) loadingSetter(false);
};
